export default __webpack_public_path__ + "static/media/pending.50247ccb.jfif";